export default __webpack_public_path__ + "static/media/default.5ccf5476.svg";